import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const [userInfo, setUserInfo] = useState({}); // Estado para armazenar as informações do usuário
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (savedToken && savedUserInfo) {
      setToken(savedToken);
      setUserInfo(savedUserInfo);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = async (email, senha) => {
    try {
      setLoading(true);
      
      const response = await fetch('https://pf-auditores.ew.r.appspot.com/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, senha }),
      });

      if (!response.ok) {
        throw new Error('Failed to login');
      }

      const data = await response.json();
      const newToken = data.token;
      const newUserInfo = { id: data.id, nome: data.nome, email: data.email, cargo: data.cargo, tipo: data.tipo};
      
      setToken(newToken);
      setUserInfo(newUserInfo);
      localStorage.setItem('token', newToken);
      localStorage.setItem('userInfo', JSON.stringify(newUserInfo));
      setIsAuthenticated(true);
      setLoading(false);
      navigate('/dashboard');
    } catch (error) {
      console.error('Error during login:', error);
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    setIsAuthenticated(false);
    navigate('/login');
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout, userInfo }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
